import React, { Component } from "react";

const ServiceList = [
    {
        icon: '01',
        title: 'Business Strategy',
        description: 'We align technology with your goals through planning, process design, and digital roadmaps.'
    },
    {
        icon: '02',
        title: 'Website Development',
        description: 'Custom websites and web apps built for performance, security, and a great user experience.'
    },
    {
        icon: '03',
        title: 'Marketing & Reporting',
        description: 'Insights and reporting tools so you can measure what matters and make better decisions.'
    },
]

class ServiceOne extends Component{
    render(){
        return(
            <React.Fragment>
                <div className="row">
                    {ServiceList.map( (val , i) => (
                        <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                            <div className="service service__style--1">
                                <div className="icon">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/icons/icon-${val.icon}.png`} alt="Digital Agency"/>
                                </div>
                                <div className="content">
                                    <h4 className="title">{val.title}</h4>
                                    <p>{val.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceOne;